import { State, ComposedMetricsSite, SummaryRequestSuccess } from "./types";

export function composeSiteProperties(
  state: State,
  action: SummaryRequestSuccess
) {
  const maxCount = Math.max.apply(
    Math,
    action.sites.map((id) => action.bySite[id][action.metricsType])
  );

  return action.sites
    .map((siteId: string) => {
      const site: ComposedMetricsSite | undefined = state.sites.get(siteId);
      if (site === undefined) throw new Error("Unkownn site");

      const count = action.bySite[siteId][action.metricsType];
      return {
        ...site,
        fill: count / maxCount,
        count,
      };
    })
    .sort((a, b) => (b.count <= a.count ? -1 : 1));
}
